export function getParams (state){
    return state.params
}



// WEBPACK FOOTER //
// ./src/modules/param-tables/getters.js